import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/Login/Login";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Patient from "./Pages/Patient/Patient";
import Laboratory from "./Pages/Laboratory/Laboratory";
import Billings from "./Pages/Billings/Billings";
import Appointments from "./Pages/Appointments/Appointments";
import MedicalRecords from "./Pages/MedicalRecords/MedicalRecords";
import Department from "./Pages/Department/Department";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/patient" element={<Patient />} />
        <Route path="/laboratory" element={<Laboratory/>} />
        <Route path="/Billings" element={<Billings/>} />
        <Route path="/Appointments" element={<Appointments/>} />
        <Route path="/medical-records" element={<MedicalRecords/>} />
        <Route path="/department" element={<Department/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;